module.exports = __webpack_public_path__ + "static/media/charging-station.c8e81887.svg";